import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { connect } from 'react-redux';

import './index.css';
import { toggleSidebar } from '../../actions';
import phone from '../../images/header/phone.svg';
import leoTrado from '../../images/main/logo.svg';
import mobilePhone from '../../images/phone-mobile.svg';
import menu from '../../images/menu-mobile.svg';

class Header extends React.Component {
  header = React.createRef();
  state = {
    background: '0',
    startAnimation: false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.handleScroll();
    }
  }

  handleScroll = () => {
    let scroll = window.pageYOffset || document.documentElement.scrollTop;
    let q = 0;
    if (window.innerWidth >= 1001) {
      if (!isFinite(q)) {
        q = 0;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }
      if (scroll >= 1 && scroll <= 499) {
        q = scroll * 0.0016;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      } else if (scroll >= 500) {
        q = 1;

        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      } else {
        this.header.current.style.backgroundColor = 'rgba(34,38,43,0)';
      }
    
    }
    else if (window.innerWidth >= 415 && window.innerWidth <= 1000) {
      if (!isFinite(q)) {
        q = 0;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }
      if (scroll >= 1 && scroll <= 300) {
        q = scroll * 0.0017;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }
      else if (scroll >= 301) {
        q = 1;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }

    }
    else if (window.innerWidth <= 414) {
      if (!isFinite(q)) {
        q = 0;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }
      if (scroll >= 1 && scroll <= 290) {
        q = scroll * 0.002;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }
      else if (scroll >= 291) {
        q = 1;
        this.header.current.style.backgroundColor = `rgba(34,38,43,${q})`;
      }
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { isMain, headerAnimationStart, animationIsEnded } = this.props;

    return (
      <div
        ref={this.header}
        id="header"
        className={["header", !animationIsEnded && isMain ? headerAnimationStart ? "header-hide header-show" : "header-hide" : ""].join(" ")}>
        <Link
          to="/"
          className="header__logo">
          <SVG
            src={leoTrado}
            alt="Leo Trado"
            className="header__logo__img" />
        </Link>
        <div className="header__navigation">
          <NavLink
            to="/mobile"
            className="header__navigation__link"
            activeClassName="header__navigation__link-active">Mobile</NavLink>
          <NavLink
            to="/web"
            className="header__navigation__link"
            activeClassName="header__navigation__link-active">Web</NavLink>
          <NavLink
            to="/portfolio"
            className="header__navigation__link"
            activeClassName="header__navigation__link-active">{ localStorage.getItem('lang') == 'ru'? 'Портфолио':'Portfolio'}</NavLink>
          <NavLink
            to="/about"
            className="header__navigation__link"
            activeClassName="header__navigation__link-active">{ localStorage.getItem('lang') == 'ru'? 'О нас':'About'}</NavLink>
        </div>
        <div className="header__contacts">
        {localStorage.getItem('lang') == 'ru'? <a href="tel: +7 (903) 406-64-99" className="header__contacts__phone">+7 (903) 406-64-99</a>:
        <a href="tel: +1 (818) 851-1502" className="header__contacts__phone">+1 (818) 851-1502</a>}
        </div>
        <div className="header__mobile">
          { localStorage.getItem('lang') == 'ru'? <a href="tel: +7 (903) 406-64-99"><SVG src={mobilePhone} /></a>:<a href="tel: +1 (818) 851-1502"><SVG src={mobilePhone} /></a>}
          <div onClick={() => this.props.toggleSidebar(true)}>
            <SVG src={menu} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ animationIsEnded }) => {
  return {
    animationIsEnded
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: (flag) => dispatch(toggleSidebar(flag)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/index.jsx